import React from 'react';
import { Link } from 'react-router-dom';
import type { Job } from '../../types';
import { StateBadge } from '../ui/StateBadge';
import { Avatar } from '../ui/Avatar';
import { MaterialIcon } from '../ui/MaterialIcon';
import { formatRelativeTime, truncateText } from '../../utils/helpers';

interface JobCardProps {
  job: Job;
}

// Calca JobCard variant="card" de components.jsx (Claude Design)
export const JobCard: React.FC<JobCardProps> = ({ job }) => {
  const client = job.client;

  return (
    <Link
      to={`/jobs/${job.id}`}
      className="group block bg-surface rounded-[18px] border border-outlineVarWarm p-4 hover:shadow-md transition-all duration-200"
    >
      <div className="flex items-center justify-between gap-3 mb-2.5">
        <div className="flex items-center gap-2">
          <StateBadge status={job.status} />
          {job.is_urgent && <StateBadge status="urgent" />}
          {job.category && <span className="text-[11px] text-onSurface-mute">{job.category.name}</span>}
        </div>
        <span className="text-[11px] text-onSurface-mute whitespace-nowrap shrink-0">{formatRelativeTime(job.created_at)}</span>
      </div>

      <h3 className="text-[16px] font-semibold leading-snug text-onSurface mb-1.5 line-clamp-2 group-hover:text-primary-700 transition-colors">
        {job.title}
      </h3>

      <p className="text-[13px] text-onSurface-var mb-3 line-clamp-2 leading-relaxed">{truncateText(job.description, 140)}</p>

      {job.skills && job.skills.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-3">
          {job.skills.slice(0, 3).map((skill) => (
            <span key={skill.id} className="text-[11px] px-2 py-0.5 bg-surface-dim text-onSurface-var rounded-full">
              {skill.name}
            </span>
          ))}
        </div>
      )}

      <div className="flex items-center justify-between pt-1">
        <div className="flex items-center gap-2 min-w-0">
          {client && <Avatar src={client.avatar} name={client.full_name} size="xs" />}
          <span className="text-xs text-onSurface-var truncate inline-flex items-center gap-1">
            <MaterialIcon name="location_on" size={13} className="text-onSurface-mute" />
            {job.city || 'Sin ubicación'}
          </span>
        </div>
        <span className="text-[17px] font-bold text-primary-700 tracking-tight shrink-0">{job.budget_range}</span>
      </div>
    </Link>
  );
};
